import React from "react";
import BottomNav from "@/components/BottomNav";

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <div className="max-w-lg mx-auto pb-28 min-h-screen">{children}</div>
      <BottomNav />
    </div>
  );
}
